"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidDate = isValidDate;
exports.isIsoDate = isIsoDate;
exports.isValidDateString = isValidDateString;
exports.isValidTimeString = isValidTimeString;
exports.getHoursFromTimeString = getHoursFromTimeString;
exports.getMinutesFromTimeString = getMinutesFromTimeString;
exports.localEquivalentOfUTC = localEquivalentOfUTC;
exports.UTCEquivalentOfLocal = UTCEquivalentOfLocal;
exports.timeToDate = timeToDate;

function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
}
/**
 * Checks that a string starts with yyyy-mm-dd
 */


function isIsoDate(dateString) {
  var isoDateRegex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]).*$/;
  return isoDateRegex.test(dateString);
}

function isValidDateString(dateString) {
  var date = new Date(dateString);
  return isIsoDate(dateString) && isValidDate(date);
}
/**
 * Checks that a string is in hh:mm format, where hour is from 0 to 23
 */


function isValidTimeString(timeString) {
  var timeRegex = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
  return timeRegex.test(timeString);
}
/**
 * Returns numeric hours from 0 to 23
 * @param {string} timeString – valid time string in hh:mm format, where hours are from 0 to 23
 */


function getHoursFromTimeString(timeString) {
  return parseInt(timeString.substring(0, 2), 10);
}
/**
 * Returns numeric minutes from 0 to 59
 * @param {string} timeString – valid time string in hh:mm format
 */


function getMinutesFromTimeString(timeString) {
  return parseInt(timeString.substring(3, 5), 10);
}

function isNullOrUndefined(value) {
  return value == null;
}
/*
  This returns the browser equivalent date/time of the given UTC date from
  the server. Equivalent does not mean the same absolute time (that would require
  no conversion). It is the same relative time.
  For example: given then end of the day in UTC, it returns the end of the day
  in the local browser time. Given 2:00pm UTC, it returns 2:00pm browser time.
*/


function localEquivalentOfUTC(utcDate) {
  if (isNullOrUndefined(utcDate)) {
    return null;
  }

  var date = typeof utcDate === 'string' ? new Date(utcDate) : utcDate;
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
}

function UTCEquivalentOfLocal(localDate) {
  if (isNullOrUndefined(localDate)) {
    return null;
  }

  var date = typeof localDate === 'string' ? new Date(localDate) : localDate;
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
}
/**
 * Returns current day with hours and minutes set to the provided time.
 * @param {string} time – valid time string in hhmm format (Note: there is no ":" delimiter between hours and minutes)
 */


function timeToDate(time) {
  if (time) {
    var now = new Date();
    var hours = time.substring(0, 2);
    var minutes = time.substring(2, 4);
    now.setHours(parseInt(hours, 10));
    now.setMinutes(parseInt(minutes, 10));
    now.setSeconds(0);
    return now;
  }

  return null;
}